import type React from "react";

import { rgba } from "@similarweb/styles";
import { Type } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { StyledCompanyLogo } from "./styles";

type Props = {
    src?: string;
    disabled?: boolean;
    className?: string;
    isEmpty?: boolean;
};

export const CompanyLogo: React.FC<Props> = ({ src, disabled = false, className, isEmpty = false }) => {
    if (isEmpty) {
        return (
            <span
                className="ItemIcon ItemIcon--website"
                data-automation="item-icon"
                data-automation-type={Type.Website}
            >
                <Box
                    width="16px"
                    height="16px"
                    background={rgba("#2A3E52", 0.2)}
                    borderRadius="3px"
                />
            </span>
        );
    }
    return (
        <StyledCompanyLogo
            iconType={Type.Website}
            iconSrc={src as string}
            disabled={disabled}
            className={className}
        />
    );
};
